module.exports = __webpack_public_path__ + "img/20191227160008957.972629f1.jpg";